var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pw-info-card",class:_vm.classString},[_c('i',{staticClass:"mdi mdi-information"}),(_vm.$slots.default)?_c('span',{staticClass:"pw-info-card__detail"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }